<div class="row ss-top-menu">
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
      <span class="ss-text-light navigation-indicators">Dashboard
        <i class="rightArrow fa fa-angle-right"></i>
      </span>
        <span class="ss-text-dark navigation-indicators">PO Dashboard</span>
        <span class="ss-text-dark navigation-indicators" *ngIf="activeTab">
            <i class="rightArrow fa fa-angle-right"></i> {{activeTab}}
      </span>
      </div>
    </div>
    <div class="row task-cards">
      <a class="nav-link ss-nav-link card addCursor " id="handover-for-production" (click)="activateTab('retail_po')" [ngClass]="{'active': selectedTab == 'retail_po'}" [routerLink]="['/po-dashboard/retail-po']">
        <div class="card-header border-bottom-0  text-center bg-white" style="margin: auto;">
         Retail PO (<span>{{countretail.total_pos}}</span> Orders) <br />
       {{countretail.total_po_amount  | indaincur}} Total Value 
        </div> 
      </a> 
      <a class="nav-link ss-nav-link card  addCursor" id="custom-element-approvals-tab" (click)="activateTab('maintenance_po')" [ngClass]="{'active': selectedTab == 'maintenance_po'}">
        <div class="card-header border-bottom-0  text-center bg-white" style="margin: auto;width: 107%;">
         Maintenance PO (<span>{{podetails.total_pos}}</span> Orders) <br />
         {{podetails.total_po_amount | indaincur }} Total Value
        </div>
      </a>
  
    </div>
    <div class="row"> 
      <div class="col-3 mt-5">
        <span style="font-weight: bold;">Maintenance PO</span> 
      </div>
      <div class="col-9 mt-5 d-flex justify-content-end">
        <div class="statusfilter mr-2">
         <select class="downloadBtn filter-status" (change)="filterStatus($event)">
            <option selected value="">
          All
        </option>
        <option value="pending">
          Waiting for Approval
        </option>
         
      </select>
      </div>
        <button (click)="downloadexcell()" class="addCursor downloadBtn mr-2 btn mb-1"
                    >
                    Download Excel Report
                  </button>
        </div> 
  
    </div>
    <div class="rk-ui-notification err" *ngIf="msgError" style="z-index: 10000 !important">
        <span id="notificationMessageText">{{errorMessage}}</span>
        <a class="close link" (click)="msgError=false" >×</a>
      </div>
      <div class="rk-ui-notification" *ngIf="successError">
        <span id="notificationMessageText">{{successMessage}}</span>
       <a class="close link" (click)="successError=false" >×</a>
      </div>
    
    <div class="row mt-4" style="margin-right: 0%;margin-left: 0%;">
      <div class="col-12"> 
        <div class="row " style="background-color: #fff;">
      <div class="col-8 " style="padding: 2rem;">
        <span class="fltype" >Search</span>
        <input
                  type="text"
                  name="searchInput"
                  style="width: 100%;"
                  class="mt-3"
                  placeholder="Search For PO Number, Vendor Name"
                  (keydown.enter)="searchFilter($event)"
                  [(ngModel)]="searchstring"
                />
      </div> 
      <div class="col-5 filter2 ">
       <div>
       <span  class="fltype" >Filter By</span>
          <label class="pl-1" style="color: #8d0528;">
            <input type="radio" value="edd" checked="{{ date_type == 'edd' ? 'checked' : '' }}" (change)="changeDateType($event.target.value)">
           EDD
          </label>
     <label class="pl-1" style="color: #8d0528;">
        <input type="radio" value="c_date" checked="{{ date_type == 'c_date' ? 'checked' : '' }}" (change)="changeDateType($event.target.value)">
        PO Creation Date
      </label>
      
      </div>
          <span class="text-danger pull-right text-bold cursor-pointer mt-1" (click)="ClearDateFilter()" style="font-size: 14px">Clear</span>
          <div class="floptions d-flex mt-3">
              <input [owlDateTime]="dt1" style="width: 100px;" [owlDateTimeTrigger]="dt1" placeholder="Select Date"  class=" rk-form-fontsize d-block rounded px-2 p-1" [(ngModel)]="from_date" >
           <owl-date-time #dt1 [pickerType]="'calendar'"></owl-date-time> <span style="font-weight:lighter;" class="ml-4 mt-1"> To </span>
           <input [owlDateTime]="dt2" style="width: 100px;" [owlDateTimeTrigger]="dt2" placeholder="Select Date"  class=" rk-form-fontsize d-block  rounded px-2 ml-3 p-1" [attr.value]="to_date | date: 'yyyy-MM-dd'" [(ngModel)]="to_date" [min]="from_date">
           <owl-date-time #dt2 [pickerType]="'calendar'" ></owl-date-time>
           <button class="btn btn-sm go-filter ml-4" style="margin-left: 6.2rem !important;"  (click)="submitByDate()">GO</button>
        </div>
      </div> 
      </div>
      </div>
    </div>
    
    <div class="row mt-3">
      <div class="col-12 ">
        <table style="width: 100%; white-space: initial !important">
           <tr class="bg_color">
            <th scope="col" class="padd-lead" style="background-color: #fff;padding-left: 25px;">PO Number</th>
           
            <th scope="col" class="padd-lead" style="background-color: #fff">Vendor Name</th>
            <th scope="col" class="padd-lead" style="background-color: #fff">PO Creation Date</th>
            <th scope="col" class="padd-lead" style="background-color: #fff;">Expected Delivery Date</th>
            <th scope="col" style="padding-right: 10rem !important; background-color: #fff;">Status </th>
            <th scope="col" style="padding-right: 10rem !important; background-color: #fff;">PO Amount</th>
             <th scope="col" style="padding-right: 10rem !important; background-color: #fff;">PO Tag</th>
            <th ope="col" colspan="5" class="padd-lead" style="background-color: #fff;"></th>
              </tr>
              <ng-container *ngFor="let po of purchase_orders  | paginate
              : {
                itemsPerPage: per_page,
                currentPage: current_page,
                totalItems: total_page
              }; let i = index">
                <tr class="row_style"  (click)="toggleRow(po,i);getslidetails(po)" style="cursor: pointer;">
                 <td style="padding-left: 25px;">
                  {{po.po_name}}
                  </td>
                  <td *ngIf=" po.line_items[0] && po.line_items[0].wip_sli.attributes.vendor_name" style="padding-right: 10px;">
                  {{po.line_items[0].wip_sli.attributes.vendor_name}}
                  </td>
                  <td *ngIf="!po.line_items[0] " style="padding-right: 10px;">
                  
                  </td>

                    <td  style="padding-right: 10px;">
                      {{po.created_at  | date:'dd-MM-yyyy' }}
                  
                  </td>
                  <td >
                  {{po.current_expected_delivery_date | date:'dd-MM-yyyy'}}
                  </td>
                  
                  <td *ngIf="po.status !=='pending'" class="text-capitalize">
                  {{po.status}}
                 </td>
                  <td *ngIf="po.status =='pending'" class="text-capitalize">
                  Po Created
                 </td>
                 <td >
                  {{po.po_amount | currency :'INR':'symbol':'1.2-2'}}
                  </td>
                  <td class="text-capitalize" *ngIf=" po.line_items[0] && po.line_items[0].wip_sli.attributes.po_tag">
                  {{po.line_items[0].wip_sli.attributes.po_tag}}
                  </td>
                  <td *ngIf="!po.line_items[0]">

                  </td>
                 
                  <td  colspan="5" ><i class="fa fa-angle-up" style="font-size: 25px;cursor: pointer;"
                    *ngIf="expansion == po.id"></i><i class="fa fa-angle-down" style="font-size: 25px;cursor: pointer;"
                    *ngIf="expansion !== po.id" style="cursor: pointer;font-size: 25px"></i>
                  </td>
                  
                  </tr>
              <ng-container *ngIf="expansion == po.id">
                <tr>
                  <th style="padding-left: 15px;" colspan="8" class="mt-2">PO Recieve Table</th>
                  <th class="mt-2 text-center"  style="min-width: 300px;">
                    <ng-container>
                      <div>
                      <button class="btn  btn-modify" style="cursor: pointer;"type="button" (click)="editsPO(po, i)" data-toggle="modal" data-target="#editPOModal" *ngIf="role != 'finance'">Edit EDD</button>
                      <button class="btn  btn-prev ml-1"  style="cursor: pointer;" type="button" data-toggle="modal" data-target="#poPreviewModal"
                       (click)="getPOPdfForPreview(po)">Preview PO</button>
                       <button *ngIf="po.status !=='cancelled' && role != 'finance'" class="addCursor btn btn-outline-secondary mt-2" data-toggle="modal" data-target="#uploadModal">Upload Invoice</button>
                      
                      </div>
                       </ng-container>
    
    
    
                  </th>
                </tr>
                  <tr  attr.id="Location{{i}}" style="padding: 15px;" class="location">
                    <td colspan="11" class="p-0">
                     <table style="width: 100%; white-space: initial !important;padding: 15px;">
                     <tr style="border: 2px solid;">
                    <th scope="col" style="background-color: #fff;padding-left: 30px;" class="padd-right">Sli Name </th>
                   <th scope="col" style="background-color: #fff;padding-left: 0.5rem;" class="padd-right">Quantity </th>
                    <th scope="col" style="background-color: #fff;" class="padd-right">Unit </th>
                    <th scope="col" style="background-color: #fff;" class="padd-right">Rate</th>
                    <th scope="col" style="background-color: #fff;" class="padd-right">Tax Type</th>
                    <th scope="col" style="background-color: #fff" class="padd-right">Tax %</th>
                    <th scope="col" style="background-color: #fff" class="padd-right">Total Amount</th>
                     </tr>
                     <ng-container>
                       <tr class="row_cascading"  *ngFor="let item of po.line_items;let i=index"  >
                      <td class="text-capitalize" style="background-color: #fff9fa;padding-left: 30px;">{{item.wip_sli.attributes.sli_name | replaceChar }}</td>
                      <td style="background-color: #fff9fa;padding-left: 25px;">{{item.wip_sli.attributes.quantity}}</td>
                      <td style="background-color: #fff9fa;    padding-left: 0.4rem;">{{item.wip_sli.attributes.unit}}</td>
                      <td style="background-color: #fff9fa;    padding-left: 0.4rem;">{{item.wip_sli.attributes.rate}}</td>
      
                     
                      <td style="text-transform: uppercase;background-color: #fff9fa;padding-left: 0.5rem;">{{item.wip_sli.attributes.tax_type| replaceChar}}</td>
                      <td style="background-color: #fff9fa">{{item.wip_sli.attributes.tax}}</td>
                     <td style="background-color: #fff9fa;padding-left: 0.3rem;">{{item.wip_sli.attributes.amount | currency :'INR':'symbol':'1.2-2'}}</td>
      
                    </tr>
                      
      
                     </ng-container>
                  </table>
                 
          </td>
          </tr>
          <tr *ngIf="po.bulk_invoice_file_details.bulk_po_performa_invoice_files.length >0">
        <th style="padding-left: 15px;" colspan="8" class="mt-2">Invoice</th>
        <th class="mt-2" style="min-width: 160px;">
         


        </th>
      </tr>
       <tr *ngIf="po.bulk_invoice_file_details.bulk_po_performa_invoice_files.length >0" attr.id="Location{{i}}" style="padding: 15px;" class="location">
        <td colspan="11" class="p-0">
         <table style="width: 100%; white-space: initial !important;padding: 15px;">
         <tr style="border: 2px solid;">
         <th scope="col" style="background-color: #fff;padding-left: 51px;">Invoice No </th>
        <th scope="col" style="background-color: #fff;" class="padd-right">Invoice Date </th>
       <th scope="col" style="background-color: #fff;" class="padd-right">Invoice Amount </th>
        <th scope="col" style="background-color: #fff;" class="padd-right">Tax Amount</th>
        <th scope="col" style="background-color: #fff;" class="padd-right">Payment Date</th>
        
        <th scope="col" style="background-color: #fff;" class="padd-right">Attachment</th>
         <th scope="col" style="background-color: #fff;" class="padd-right">Balance Due</th>
        <th scope="col" colspan="2" style="background-color: #fff" class="padd-right"></th>
       
         </tr>
         <ng-container *ngFor="let item of po.bulk_invoice_file_details.bulk_po_performa_invoice_files ;let i=index">
        
 <tr class="row_cascading"   >
             <td style="padding-left: 20px;background-color: #fff9fa;min-width: 200px"> <button class="btn cursor-pointer " (click)="openPanel(item.id)" *ngIf="selected_item !== item.id" style="background-color: #fff9fa;padding: 0.5rem 0.4rem;">
                          <i class="fa fa-plus-square-o" aria-hidden="true" ></i>
                        </button>
                        <button class="btn cursor-pointer "  (click)="openPanel(item.id)" *ngIf="selected_item === item.id" style="background-color: #fff9fa;padding: 0.5rem 0.4rem;">
                          <i class="fa fa-minus-square-o" aria-hidden="true"  ></i>
                        </button>
            
             <span>{{item.invoice_number}} </span></td>
                <td class="text-capitalize" style="background-color: #fff9fa;padding-left: 0.2rem;">{{item.invoice_date | date:'dd-MM-yyyy' }}</td>
               <td style="background-color: #fff9fa;padding-left: 0.6rem;">{{item.invoice_amount | currency :'INR':'symbol':'1.2-2'}}</td>
             <td style="background-color: #fff9fa;padding-left: 1rem;">{{item.tax_amount | currency :'INR':'symbol':'1.2-2'}}</td>
             <td style="background-color: #fff9fa;padding-left: 0.5rem;"> {{item.payment_date | date:'dd-MM-yyyy'}}</td>
             <td style="background-color: #fff9fa;padding-left: 1.5rem;"><a href="{{ item.url }}" target="_blank"><i class="fa fa-cloud-download  download-icon" aria-hidden="true"></i>
                        </a>
            
              </td>
               <td style="background-color: #fff9fa;padding-left: 1rem;">{{item.balance | currency :'INR':'symbol':'1.2-2'}}</td>
        
               <td style="background-color: #fff9fa;padding-right: 50px;" class="clubbed-container">
               <div class="clubbed-parameter d-flex" style="white-space: nowrap;">
              <ng-container>
              <button class="btn  btn-rel" type="button" (click)="raiseRequest(item.id)" *ngIf="item.id !== selectedInvoice && item.balance > 0.0 && role != 'finance'" style="cursor: pointer;">Release
              </button>
              <input type="number" style="width: 150px;" class="form-control ml-1" *ngIf="item.id == selectedInvoice" id="amt-{{item.id}}" min="0" (keyup)="handleNegativeValue($event,item.id)"/>
             

                <button  class="btn-new" (click)="submitRequest(item.id,item.balance)" *ngIf="item.id === selectedInvoice">
                  <img  height="30px"  src="assets/v3/img/White_Arrow.svg">
                </button>
                <button class="btn-new"   (click)="cancelRequest()" *ngIf="item.id === selectedInvoice">
                  <i class="fa fa-times-circle" style="
                      font-size: 2.4em;
                      color: #8c031f;
                      cursor: pointer;
                  "></i>
                </button> 
                <span class="text-success font-weight-bold ml-2" *ngIf="item.balance == 0.0">No Balance Due</span>
                <button class="btn  btn-cancel  ml-2" style="cursor: pointer;" type="button" (click)="deleteinvloice(item.id,po)" *ngIf="role !='finance'"
                >Delete</button>
               </ng-container>
               </div>
                 </td>
                 </tr>
             
             <ng-container *ngIf="selected_item == item.id">
       

              <tr *ngIf="item.bulk_pi_payments.length > 0" attr.id="Location{{i}}"  class="location">
                 <td colspan="11" class="p-0">
                 <table style="width: 100%; white-space: initial !important;padding: 15px;
    background-color: #cccccc7a;">
                 <tr style="border: 2px solid;">
                 <th scope="col" style="background-color: #fff;padding-left: 25px;padding-right: 50px;min-width: 166px;">Payment Status </th>
                <th scope="col" style="background-color: #fff;min-width: 264px;" class="padd-right">Description </th>
               <th scope="col" style="background-color: #fff;" class="padd-right"> Amount</th>
                <th scope="col" style="background-color: #fff;" class="padd-right">Approved Amount</th>
                <th scope="col" style="background-color: #fff;" class="padd-right">UTR Number</th>
                <th scope="col" style="background-color: #fff;" class="padd-right">ICICI Payment Status</th>
                <th scope="col" style="background-color: #fff;" class="padd-right">Approve/Reject</th>
                <th scope="col" style="background-color: #fff" class="padd-right">Updated At</th>
                 </tr>
    
      <ng-container *ngFor="let item2 of item.bulk_pi_payments;let i=index">
                   <tr class="row_cascading">
                  <td *ngIf="item2.payment_status == 'waiting_for_approval' " style="padding-left: 25px;background-color: #f2f2f2;padding-right: 2.2rem;"><ng-container *ngIf="item2.payment_split == true">
                        <button class="btn cursor-pointer " (click)="openPanel2(item2.id)" *ngIf="selected_item2 !== item2.id" style="background-color: #f2f2f2;padding: 0.5rem 0.4rem;">
                          <i class="fa fa-plus-square-o" aria-hidden="true" ></i>
                        </button>
                        <button class="btn cursor-pointer "  (click)="openPanel2(item.id)" *ngIf="selected_item2 === item2.id" style="background-color: #f2f2f2;padding: 0.5rem 0.4rem;">
                          <i class="fa fa-minus-square-o" aria-hidden="true"  ></i>
                        </button>
                        </ng-container>Finance Approved</td>
                   <td *ngIf="item2.payment_status !== 'waiting_for_approval' " style="padding-left: 25px;background-color: #f2f2f2;padding-right: 2.2rem;"><ng-container *ngIf="item2.payment_split == true">
                        <button class="btn cursor-pointer " (click)="openPanel2(item2.id)" *ngIf="selected_item2 !== item2.id" style="background-color: #f2f2f2;padding: 0.5rem 0.4rem;">
                          <i class="fa fa-plus-square-o" aria-hidden="true" ></i>
                        </button>
                        <button class="btn cursor-pointer "  (click)="openPanel2(item.id)" *ngIf="selected_item2 === item2.id" style="background-color: #f2f2f2;padding: 0.5rem 0.4rem;">
                          <i class="fa fa-minus-square-o" aria-hidden="true"  ></i>
                        </button>
                        </ng-container>{{item2.payment_status | replaceChar}}<span *ngIf="item2.payment_status === 'rejected'">&nbsp;({{item2.remarks}})</span></td>
                  <td class="text-capitalize" style="background-color: #f2f2f2">{{item2.description | replaceChar }}</td>
                <ng-container *ngIf="item2.payment_split == false">
                  <td style="background-color: #f2f2f2;padding-left: 20px;">{{item2.amount | currency :'INR':'symbol':'1.2-2'}}</td>
                  </ng-container>
                  <ng-container *ngIf="item2.payment_split == true">
                  <td style="background-color: #f2f2f2;padding-left: 20px;">{{item2.total_amount_added | currency :'INR':'symbol':'1.2-2'}}</td>
                  </ng-container>
                  <td style="background-color: #f2f2f2;padding-left: 1rem;">{{item2.approved_amount | currency :'INR':'symbol':'1.2-2' }}</td>
                  <td style="background-color: #f2f2f2">
                   <ng-container *ngIf="item2.external_payment && item2.external_payment.status === 'approved'">{{item2.external_payment?.unique_id}}</ng-container>
                                        <ng-container *ngIf="item2.external_payment && item2.external_payment.status !== 'approved'"><span class="text-danger">Not Exists</span></ng-container>
                  </td>
  
                 
                  <td style="text-transform: uppercase;background-color: #f2f2f2">
                    {{ item2.external_payment?.status }}
                  </td><td style="background-color:#f2f2f2;;">
 <img style="cursor: pointer;" *ngIf="item2.payment_status == 'pending' && current_user === 'category_head'"  class="ml-2" src="./assets/img/finance/path.png"  (click)="handleApproveRejectEvent('approve',item2.id)">
                          <img style="cursor: pointer;" *ngIf="item2.payment_status == 'pending' && current_user === 'category_head'" class="ml-3"   src="./assets/img/finance/close.png" (click)="handleApproveRejectEvent('reject',item2.id)">                    
                  </td>
                  <td style="background-color:#f2f2f2;padding-left: 0.2rem;">
                     {{item2.updated_time | date:'dd-MM-yyyy' }} 
                  </td>
  
                </tr>
               <ng-container *ngIf="selected_item2 == item2.id">
                 <td colspan="11" class="p-0">
                 <table style="width: 100%; white-space: initial !important;padding: 5px;background-color: #8d0528;">
                   <tr style="border: 2px solid;">
                 <th scope="col" style="background-color: #fff;padding-left: 25px;">Payment Status </th>
                <th scope="col" style="background-color: #fff;" class="padd-right">Description </th>
               <th scope="col" style="background-color: #fff;padding-left: 50px;" class="padd-right2"> Amount</th>
                <th scope="col" style="background-color: #fff;" class="padd-right2">Approved Amount</th>
                <th scope="col" style="background-color: #fff;" class="padd-right2">UTR Number</th>
                <th scope="col" style="background-color: #fff;" class="padd-right2">ICICI Payment Status</th>
                <!-- <th scope="col" style="background-color: #fff;" class="padd-right">Approve/Reject</th> -->
                <th scope="col" style="background-color: #fff" class="padd-right2">Updated At</th>
                 </tr>
      <tr class="row_cascading"  *ngFor="let item3 of item2.split_payments;let j=index" >
                     
                     <td *ngIf="item3.payment_status == 'waiting_for_approval' " style="padding-left: 25px;background-color: #f2f2f2;">
                      
                      <span>Finance Approved</span></td>
                     
                     <td *ngIf="item3.payment_status !== 'waiting_for_approval' " style="padding-left: 25px;background-color: #f2f2f2;">
                      
                      <span>{{item3.payment_status | replaceChar}}</span><span *ngIf="item3.payment_status === 'rejected'">&nbsp;({{item3.remarks}})</span></td>
                  <td class="text-capitalize" style="background-color: #f2f2f2">Splitted By {{item3.split_user.email}}</td>
                  
                  <!-- <ng-container *ngIf="item2.payment_split === false"> -->
                  <td style="background-color: #f2f2f2;padding-left: 3.6rem;">{{item3.amount | currency :'INR':'symbol':'1.2-2'}}</td>
                  <!-- </ng-container> -->
                  <!-- <ng-container *ngIf="item2.payment_split === true">
                  <td style="background-color: #f2f2f2;padding-left: 3.6rem;">{{item3.total_amount_added | currency :'INR':'symbol':'1.2-2'}}</td>
                  </ng-container> -->
                  <td style="background-color: #f2f2f2;padding-left: 1rem;">{{item3.approved_amount | currency :'INR':'symbol':'1.2-2'}}</td>
                  <td style="background-color: #f2f2f2">
                   <ng-container *ngIf="item2.external_payment && item2.external_payment.status === 'approved'">{{item3.external_payment?.unique_id}}</ng-container>
                                        <ng-container *ngIf="item2.external_payment && item2.external_payment.status !== 'approved'"><span class="text-danger">Not Exists</span></ng-container>
                  </td>
  
                 
                  <td style="text-transform: uppercase;background-color: #f2f2f2">
                    {{ item3.external_payment?.status }}
                  </td>
                   <!-- <td style="background-color:#f2f2f2;;">                    
                  </td> -->
                  <td style="background-color:#f2f2f2;padding-left: 0.3rem;">
                     {{item3.updated_time | date:'dd-MM-yyyy' }} 
                  </td>
                 
  
                </tr>
                </table>
                </td>
                 </ng-container>
                  
  
                 </ng-container>
       
                 </table>
                 </td>
                 
                 </tr>
     
              
<ng-container *ngIf="item.bulk_pi_payments.length === 0" style="width: 100%;" class="text-center">
                              <p style="position: relative;
    left: 265%;" class="text-center text-danger">No Payment history found...</p>
                          </ng-container>
             </ng-container>
               
         </ng-container>
         </table>
         </td>
         </tr>
         
         
    </ng-container>
    </ng-container>
    </table>
    <div class="col-12 not-found" *ngIf="purchase_orders.length == 0" >
      <div class="boq-img text-center">
        <img src="../../../assets/img/desktop.png"/>
      </div>
      <p class="nothing-to-show pb-4">Nothing to show...</p>
    </div>
    <div class="text-center">
      <pagination-controls autoHide="true" (pageChange)="current_page = getItems($event)"></pagination-controls>
     </div>
         </div>
         </div>



         <div class="modal" id="poPreviewModal">
          <div class="modal-dialog modal-lg" style="max-width:890px">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">Preview PO</h4>
                <button type="button" class="close" data-dismiss="modal"
                  >&times;</button>
              </div>
              <div class="modal-body">
                <div *ngIf="isLoaded" style="text-align: center;">
                  <button class="btn btn-pink" (click)="prevPage()" [disabled]="page === 1">Prev</button>
                  <span>{{ page }} / {{ totalPages }}</span>
                  <button class="btn btn-pink" (click)="nextPage()" [disabled]="page === totalPages">Next</button>
                </div>
                <iframe *ngIf="po_preview_pdf_url" [src]="po_preview_pdf_url | safePipe:'resourceUrl'" width="850" height="600">
                </iframe>
              </div>
            </div>
          </div>
        </div>
        <div class="modal" id="editPOModal">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">Edit Expected Delivery Date</h4>
                <button type="button" class="close pr-4 wine-red" data-dismiss="modal">&times;</button>
              </div>
              <div class="modal-body">
                <form [formGroup]="milestoneeditForm" (ngSubmit)="finaleditsubmission()">
                      <div class="row">
                        <div class="col-6 form-group">
                          <label class="pull-left font-weight-bold">Expected Delivery Date</label>
                          <input [owlDateTime]="dt3" [owlDateTimeTrigger]="dt3" formcontrol placeholder="Enter Expected Date of Delievery"
                          class="form-control" [(ngModel)]="current_expected_delivery_date" (ngModelChange)="handleInvoiceDateeditSelectEvent($event)"  [ngModelOptions]="{standalone: true}" [min]="todayDate">
                       <owl-date-time #dt3 [pickerType]="'calendar'" [startView]="'month'"></owl-date-time>
                          </div>
                      </div>
                  <div class="row">
                    <div class="col-md-12">
                      <button type="submit" class="btn btn-secondary" style="height: 50px;width: 133px;margin-top:1.2rem;margin-left: 19.2rem;; background-color: #8d0528;cursor: pointer;"
                        [disabled]="!milestoneeditForm.valid" id="milestoneSubmitBtn">Submit</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
         <div class="modal" id="uploadModal" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog">
          <div class="modal-content">
             <div class="modal-header pl-5 mt-2">
                    <h4 class="modal-title   pt-3">Upload Invoice</h4>
                  <button class="close mr-4 pull-right addCursor" data-dismiss="modal" style="height: 38px;font-size: 40px;font-weight: 300; color: #8c031f" type="button" (click)="uploadInvoiceFormReset()">×</button>
              </div>
              <div class="modal-body px-5">
                <span class="text-danger font-weight-bold" *ngIf="invoice_err_msg">*{{invoice_err_msg}}</span>
                <form [formGroup]="uploadInvoiceForm">
                  
                  <div class="row">
                    <div class="col-md-12 mt-2">
                      <div  class="form-group">
                          <label class="md-check">
                            <input type="radio" value="normal" name="gender" [(ngModel)]="invoiceType" (change)="handleInvoiceSelectEvent($event)" [ngModelOptions]="{standalone: true}">
                            Invoice
                          </label>
                      
                          <label class="md-check ml-5">
                            <input type="radio" value="tax" name="gender" [(ngModel)]="invoiceType" (change)="handleInvoiceSelectEvent($event)" [ngModelOptions]="{standalone: true}">     
                            Tax Invoice
                          </label>
                        </div>                    
                    </div>
                    <div class="col-12" *ngIf="uploadInvoiceForm.get('tax_invoice').value === true">
                      <div class="form-group">
                        <label class="ss-form-label">Enter Tax Amt<span class="text-danger">*</span></label>
                        <input type="number" class="form-control" formControlName="tax_amount"/>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label class="ss-form-label">Enter Invoice Amt<span class="text-danger">*</span></label>
                        <input type="number" class="form-control" formControlName="invoice_amount" min="0"/>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label class="ss-form-label">Enter Invoice No<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="invoice_number"/>
                      </div>
                    </div>
                    <div class="col-md-6 mt-2">
                      
                       <div class="form-group">
                        <label  class="ss-form-label">Invoice Date<span class="text-danger">*</span></label>
                        <input [owlDateTime]="dt6" [owlDateTimeTrigger]="dt6" placeholder="Invoice Date"  class="form-control" [(ngModel)]="invoice_date" (ngModelChange)="handleInvoiceDateSelectEvent($event)" [ngModelOptions]="{standalone: true}">
                           <owl-date-time #dt6 [pickerType]="'calendar'"></owl-date-time> 
                       </div>
                    </div>
                    <div class="col-md-6 mt-2">
                      
                       <div class="form-group">
                        <label  class="ss-form-label">Payment Date<span class="text-danger">*</span></label>
                           <input [owlDateTime]="dt5" [owlDateTimeTrigger]="dt5" placeholder="Payment Term" [(ngModel)]="paymentTerm"  class="form-control"  [readonly]="true" [disabled]="true" [ngModelOptions]="{standalone: true}">
                           <owl-date-time #dt5 [pickerType]="'calendar'" ></owl-date-time> 
                       </div>
                    </div>
                    <div class="col-sm-12 mt-2">
                      <div class="btnborder text-center" > <p class=" bg-white mt-4 ml-4 mr-4"for="file-upload"style="font-weight: 700;font-size: 16px">
                        <label id="getFileLabel" for="getFile">Upload</label>
                        <input type="file" id="getFile" style="display: none;"  (change)="onChange($event)" />
    
                         <img class="" style="float: right;" id="imgFileUpload" alt="Select File" title="Select File" src="/assets/img/Download Icon.png" (click)="openBrowseModal()"></p>
                      </div>
                    </div>
                    <div class="col-md-12 mt-2 text-center">
                      <label class="file-color" *ngIf="file_name">{{ file_name }}</label>
                      
                    </div>
                  </div>  
                   <div class="row">
                     <div class="col-sm-12 text-center">
                       <button type="button" class="btn mb-3 mt-4 btn-pink Btn" (click)="AddRequest(uploadInvoiceForm.value)" [disabled]="!uploadInvoiceForm.valid || file_name === ''">Add</button>
                     </div>
                   </div>
                </form>
              </div>
          </div>
      </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/platform/category/category/bulk-po/bulk-po.component.html